// -------- 怪兽相关 --------
import fetch from "./http";

// 怪兽列表
export function monsterList(params) {
  return fetch({
    url: "/user/get-monster-list",
    params,
  });
}

// 切换选中怪兽
export function defaultMonster(params) {
  return fetch({
    url: "/monster/default-monster",
    params,
  });
}

// 购买怪兽
export function buyMonster() {
  return fetch({
    url: "/monster/buy-monster",
  });
}
// 喂食
export function feed() {
  return fetch({
    url: "/monster/feed",
  });
}
// 修改怪物名称
export function rename(params) {
  return fetch({
    url: "/monster/rename",
    params,
  });
}

// 可选择怪兽列表
export function selectedPetList() {
  return fetch({
    url: "/monster/category-list",
  });
}
